import { Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { motion } from "framer-motion";
import { PageHeader, PageContent } from "@adl/smart-ui-library";
import MyCasesTableWrapper from "@/components/MyCasesTableWrapper";
import DefaultTemplate from "@/templates/DefaultTemplate/DefaultTemplate";
import Notifications from "@/components/Notifications";
import { useAppDispatch } from "@/hooks";
import { setSelectedTasks } from "@/redux/tasksSlice";
import VaultIcon from "@/components/VaultIcon";
import * as Styled from "./MyCasesPage.styles";
import VaultTextLogo from "@/components/VaultTextLogo";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosConfig";

const MyCasesPage = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const onLogout = () => {
    instance.logout();
  };

  const onTaskBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/tasks`);
  };
  const onNonBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/non-p-code`);
  };
  const handleAccess = async () => {
    try {
      const response = await axiosInstance.get(`documents/nonpcode/permission/me`);
      console.log(response?.data)
      sessionStorage.setItem('accessLevelName', response?.data?.name)
      sessionStorage.setItem('accessLevel', JSON.stringify(response?.data))
    } catch (error: any) {
      console.log(error);
    }

  };
  handleAccess()
  const accessLevelName = sessionStorage.getItem('accessLevelName') || '';


  return (
    <DefaultTemplate testId="my-cases-page">
      <>
        <PageHeader
          logo={<VaultIcon width={40} height={40} />}
          navigation={
            <>
              <Notifications />
              {accessLevelName !== 'NoAccess' &&
                <Button data-testid="tasks-button" onClick={onNonBtnClick}>
                  Non-P-Code Documents
                </Button>
              }
              <Button data-testid="tasks-button" onClick={onTaskBtnClick}>
                Tasks
              </Button>
              <Button data-testid="logout-button" onClick={onLogout}>
                Logout
              </Button>
            </>
          }
        >
          <VaultTextLogo />
        </PageHeader>
        <PageContent>
          <motion.div
            initial={{ opacity: 0, width: "100%" }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0 }}
          >
            <Styled.DashboardContent>
              <MyCasesTableWrapper />
            </Styled.DashboardContent>
          </motion.div>
        </PageContent>
      </>
    </DefaultTemplate>
  );
};

export default MyCasesPage;
